export //Reemplaza en el texto de la pregunta el @pagina lo que viene por el parámetro pagina de la url. Solo Alpina lo usa
    const replaceText = (text, parametrosURL) => {
        if (parametrosURL) {
            const params = new URLSearchParams(window.location.search);
            let pagina = "";
            let canal = "";
            let cliente = "";
            if (params.size > 1) {
                pagina = params.get("pagina");
                canal = params.get("canal");
                cliente = params.get("cliente");
            }
            const replacementMap = {
                "@cliente": cliente || "ONCOSALUD",
                "@canal": canal || "@canal",
                "@pagina": pagina || "",
            };
            // const regex = new RegExp("@cliente", "g");
            const regex = /@cliente|@canal|@pagina/g;
            //const newTextAlpina = text?.replace("@pagina", pagina ? pagina : "");
            const newText = text?.replace(
                regex,
                (match) => replacementMap[match]
            );
            return newText;
        } else {
            return text;
        }
    };